import React, { Component } from 'react';
import './index.scss';

import Card from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import Divider from 'material-ui/Divider';
import SolarPackage from "../accessories/solarPackage";
import {observer,inject} from 'mobx-react';

import { OverlayTrigger,Popover } from 'react-bootstrap';

import { grey,cyan } from 'material-ui/colors';
import { withStyles } from 'material-ui/styles';
import 'rc-slider/assets/index.css';
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
import HomeAppliance from "../accessories/homeAppliance";
import ProgressLine from "../accessories/progressLine";
const Handle = Slider.Handle;

const styles = theme => ({
    progressColor: {
        primaryColor: cyan[500],
        primaryColorBar: grey[500],
    }
});

const handle = (props) => {
    const { value, dragging, index, ...restProps } = props;
    return (
        <Tooltip
            prefixCls="rc-slider-tooltip"
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}
        >
            <Handle value={value} {...restProps} />
        </Tooltip>
    );
};

const popoverFocus = (
    <Popover id="popover-trigger-focus" title="">
        <ol style={{paddingLeft: 20, color:'rgba(0,0,0,0.87)',fontFamily:'DB Heavent Li',fontSize:'1.8rem'}}>
            <li>ราคานี้ไม่รวมอุปกรณ์กันไฟ ย้อน PMU</li>
            <li>ราคานี้ไม่รวม Vat</li>
            <li>ตามข้อกำหนดของ กฟน. สามารถติดได้ไม่เกิน 5.0 kw. ต่อหลัง</li>
            <li>แผ่นโซลาร์ Tier 1</li>
            <li>อินเวอร์เตอร์ ผ่านลิสการไฟฟ้า MEA หรือ PEA</li>
        </ol>
    </Popover>
);

@inject("summaryDataStore")
@observer
class CardSetting extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    handleFirstSlider = (value) => {
        this.props.summaryDataStore.setWeekdayHour(value);
        this.props.summaryDataStore.calForShowSummary();
    };

    handleSecondSlider = (value) => {
        this.props.summaryDataStore.setWeekendHour(value);
        this.props.summaryDataStore.calForShowSummary();
    };

    render() {
        const { weekday, weekend, usePercent, powerGenerationSelected, sumKW } = this.props.summaryDataStore;
        return (
            <Card className='cardSetting'>
                <Grid container className='containerGrid' justify='center' spacing={0}>
                    <Grid xs={10} sm={10} md={10}>
                        <br/>
                        <div className='headerCard'>
                            <h1 className='headerCard'> การเลือกขนาดโซลาร์เซลล์ </h1>
                            <span className='detailCard'>ปรับแต่งอุปกรณ์โซลาร์เซลล์ และการใช้งานที่เหมาะกับคุณ</span>
                            <div style={{display:'flex',justifyContent:'flex-end'}}>
                                <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popoverFocus}>
                                    <button className='infoAdditional' ><img src='assets/info.svg' className='ic_info' /><span className='textInfo' >ข้อมูลเพิ่มเติม</span></button>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div>
                            {/*<h1> เลือกขนาดโซลาร์เซลล์ </h1>*/}
                            <SolarPackage />
                        </div>
                        <br/>
                        <Divider />
                        <br/>
                        <div>
                            <h1> ประสิทธิภาพการใช้งาน </h1>
                        </div>
                        <br/>
                        <div className='sumKW'>
                            <ProgressLine percentValue={usePercent} />
                            {/*<h3>คุณใช้กำลังไฟฟ้าไปแล้ว { this.props.summaryDataStore.format2(sumKW) } kW จาก { powerGenerationSelected } kW</h3>*/}
                            <br/>
                            <br/>
                        </div>
                        <br/>
                        <span className='comment'> คำแนะนำ: <span className='detail'> ปรับการใช้งานให้พอดีหลอด เพื่อประสิทธิภาพและความประหยัดสูงสุด </span> </span>
                        <br/>
                        <br/>
                        <br/>
                        <Divider />
                        <br/>
                        <div>
                            <h1>ปรับการใช้งานเครื่องใช้ไฟฟ้า</h1>
                            <br/>
                            <HomeAppliance />
                            <span className='comment'>
                                <span className='detail'>
                                    *หมายเหตุ:<br/>
                                    <span>- คำนวณการใช้ไฟฟ้าจากวัตต์ของเครื่องใช้ไฟฟ้า</span><br/>
                                    <span>- การคำนวณข้างต้น ประเมินรวมเครื่องใช้ไฟฟ้าที่ต้องเสียบปลั๊กตลอด 24 ชั่วโมง เช่น ตู้เย็น ปั๊มน้ำ เป็นต้น โดยมีกำลังไฟฟ้ารวม 400 วัตต์</span>
                                </span>
                                {/*<span className='detail'> *หมายเหตุ: คำนวณการใช้ไฟฟ้าจากวัตต์ของเครื่องใช้ไฟฟ้า </span> */}
                            </span>
                        </div>
                        <br/>
                        <br/>
                        <Divider />
                        <br/>
                        <div className='manageHour'>
                            <h1>เลือกช่วงเวลาที่ใช้ไฟฟ้า</h1>
                            <br/>
                            <span>คุณอยู่บ้านกี่ชั่วโมงในช่วงวันธรรมดา ช่วงเวลา 6:00 - 18:00?</span>
                            <br/>
                            <br/>
                            <div>
                                <Slider
                                    min={0}
                                    max={12}
                                    defaultValue={weekday}
                                    onChange={this.handleFirstSlider}
                                    handle={handle}
                                />
                                <br/>
                                <Grid container   spacing={0}>
                                    <Grid item xs={2} sm={2} md={2} style={{textAlign:'left',color:'rgba(0, 0, 0, 0.54)'}}>
                                        <span>0</span>
                                    </Grid>
                                    <Grid item  xs={8} sm={8} md={8} style={{textAlign:'center',fontFamily:'DB Heavent Med', fontSize:'2.4rem'}}>
                                        <span>จำนวน {weekday} ชั่วโมง</span>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} style={{textAlign:'right',color:'rgba(0, 0, 0, 0.54)'}}>
                                        <span>12</span>
                                    </Grid>
                                </Grid>
                            </div>
                            <br/>
                            <span>คุณอยู่บ้านกี่ชั่วโมงในช่วงวันหยุด ช่วงเวลา 6:00 - 18:00?</span>
                            <br/>
                            <br/>
                            <div>
                                <Slider
                                    min={0}
                                    max={12}
                                    defaultValue={weekend}
                                    onChange={this.handleSecondSlider}
                                    handle={handle}
                                    style={{backgroundColor:'#fffff'}}
                                />
                                <br/>
                                <Grid container spacing={0}>
                                    <Grid item xs={2} sm={2} md={2} style={{textAlign:'left',color:'rgba(0, 0, 0, 0.54)'}}>
                                        <span>0</span>
                                    </Grid>
                                    <Grid item  xs={8} sm={8} md={8} style={{textAlign:'center',fontFamily:'DB Heavent Med', fontSize:'2.4rem'}}>
                                        <span>จำนวน {weekend} ชั่วโมง</span>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} style={{textAlign:'right',color:'rgba(0, 0, 0, 0.54)'}}>
                                        <span>12</span>
                                    </Grid>
                                </Grid>
                                <br/>
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <br/>
            </Card>
        );
    }
}

export default withStyles(styles)(CardSetting);


// WEBPACK FOOTER //
// ./src/components/summary/cardSetting.js